/* eslint-disable */

//tslint:disable

import { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api/shared/http';
import {
  TSendPhoneConfirmationCodeModel,
  ISendPhoneConfirmationCodeRequest,
  IMappers,
  ISendPhoneConfirmationCodeResponse,
  ISendPhoneConfirmationCodeResponseError,
  TSendPhoneConfirmationCodeResponse,
} from './types';

const defaultConfig: TSendPhoneConfirmationCodeModel = {
  apiType: 'public',
  assertStatusCodes: [400, 200, 204],
  method: 'POST',
  microserviceName: 'pik-booking',
  pathApi: '/v1/send-phone-confirmation-code/',
  hostType: 'api',
} as TSendPhoneConfirmationCodeModel;

function createSendPhoneConfirmationCodeModel(
  parameters: ISendPhoneConfirmationCodeRequest,
): TSendPhoneConfirmationCodeModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface ISendPhoneConfirmationCodeOptions<TResponse400, TResponse200, TResponse204> {
  httpApi: IHttpApi;
  parameters: ISendPhoneConfirmationCodeRequest;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse400, TResponse200, TResponse204>;
}

async function fetchSendPhoneConfirmationCode<TResponse400, TResponse200, TResponse204>({
  httpApi,
  parameters,
  config,
  mappers,
}: ISendPhoneConfirmationCodeOptions<TResponse400, TResponse200, TResponse204>): Promise<
  TResponse400 | TResponse200 | TResponse204 | TSendPhoneConfirmationCodeResponse
> {
  const { response, statusCode } = await httpApi.fetch(createSendPhoneConfirmationCodeModel(parameters), config);

  if (mappers && statusCode in mappers) {
    if (statusCode === 400) {
      return mappers[400](response as ISendPhoneConfirmationCodeResponseError);
    }

    if (statusCode === 200) {
      return mappers[200](response as ISendPhoneConfirmationCodeResponse);
    }

    if (statusCode === 204) {
      return mappers[204]();
    }
  }

  return { response, statusCode } as TSendPhoneConfirmationCodeResponse;
}

export { defaultConfig, createSendPhoneConfirmationCodeModel, fetchSendPhoneConfirmationCode };
